import { allRoles, administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { contactPageActions } from "./contactPageActions";
import { contactPageConfig } from "./contactPageConfig";
import { contactPageBadges } from "./contactPageBadges";
import { contactFieldComponents } from "./contactFieldComponents";
import { contactRelatedTableActions } from "./contactRelatedTableActions";
import { adaptContactRecord } from "./contactRecordAdapter";

export const contactRecordDefinition: RecordDefinition = {
  path: "/contact",
  actions: contactPageActions,
  entityName: "contact",
  listRoute: "/contacts",
  backTitle: "Back to contacts",
  allowedRoles: allRoles,
  recordEditRoles: administratorRoles,
  config: contactPageConfig,
  identity: {
    titleFields: ["firstname", "lastname"],
    subtitleField: "emailaddress1",
    showAvatar: true,
    fallbackTitle: "Contact",
    newRecordTitle: "New Contact",
  },
  badges: contactPageBadges,
  recordAdapter: adaptContactRecord,
  fieldComponents: contactFieldComponents,
  relatedTableActions: contactRelatedTableActions,
};
